package todo.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.myrestaurants.sharedmodels.UserCredentials
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.AttrsModifier
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.verticalAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import app.AppProperties
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import org.jetbrains.compose.web.events.SyntheticInputEvent
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLScriptElement
import org.w3c.dom.HTMLStyleElement
import org.w3c.fetch.RequestInit
import org.w3c.fetch.Response
import utils.validEmail
import kotlin.js.json

object SiteConfig {

    var app: String = "myrestaurants"

    var enterAsGuest: Boolean = false

    var apiEndpoint: String = "https://www.myrestaurants.pt:442"
    var properties: AppProperties = AppProperties()

    // Social media config
    var instagramName: String = "Instagram"
    var instagramUrl: String = "https://instagram.com/myrestaurants.pt"
    var instagramIcon: String = "/social/instagram.svg"

    var facebookName: String = "Facebook"
    var facebookUrl: String = "https://facebook.com/myrestaurants.pt"
    var facebookIcon: String = "/social/facebook.svg"

    var emailName: String = "Email"
    var emailUrl: String = "mailto:main@myrestaurants.pt"
    var emailIcon: String = "/social/email.svg"

    var logo: String = "/logo.png"
    var copyrightText: String = "© 2025 My Restaurants. All rights reserved.    "
}

// Maintain backwards compatibility with existing code
var apiEndpoint = SiteConfig.apiEndpoint

// Maintain backwards compatibility with existing code
val INSTAGRAM_NAME = SiteConfig.instagramName
val INSTAGRAM_URL = SiteConfig.instagramUrl
val INSTAGRAM_ICON = SiteConfig.instagramIcon

val FACEBOOK_NAME = SiteConfig.facebookName
val FACEBOOK_URL = SiteConfig.facebookUrl
val FACEBOOK_ICON = SiteConfig.facebookIcon

val EMAIL_NAME = SiteConfig.emailName
val EMAIL_URL = SiteConfig.emailUrl
val EMAIL_ICON = SiteConfig.emailIcon

val logoMyRestaurants = SiteConfig.logo
val COPYRIGHT_TEXT = SiteConfig.copyrightText

var appProperties : AppProperties = AppProperties()

object AppBreakpoints {
    val MOBILE = Breakpoint.SM
    val TABLET = Breakpoint.MD
    val DESKTOP = Breakpoint.LG
}

val MainContainer = CssStyle.base {
    Modifier
        .padding(0.px).width(100.percent)
}

val CardStyle = CssStyle.base {
    Modifier
        .backgroundColor(rgb(255, 255, 255))
        .padding(24.px)
        .borderRadius(8.px)
        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
}

val InputStyle = CssStyle.base {
    Modifier
        .width(100.percent)
        .maxWidth(400.px)
        .padding(12.px)
        .margin(bottom = 16.px)
        .fontSize(10.px)
        .borderRadius(4.px)
        .border(1.px, LineStyle.Solid, rgb(200, 200, 200))
}

val HiddenStyle = CssStyle.base {
    Modifier
        .lineHeight(0)
        .fontSize(0.4.cssRem)
        .margin(top = 0.0.em, bottom = 0.0.em)
    //.fontWeight(FontWeight.Bold)
}

val TitleStyle = CssStyle.base {
    Modifier
        .lineHeight(1.15)
        .fontSize(3.cssRem)
        .margin(top = 0.4.em, bottom = 0.6.em)
    //.fontWeight(FontWeight.Bold)
}

val ButtonStyle = CssStyle.base {
    Modifier
        .backgroundColor(rgb(100, 100, 100))
        .color(Colors.White)
        .padding(leftRight = 0.px, topBottom = 0.px)
        .borderRadius(2.px)
        .cursor(Cursor.Pointer)
        .border(0.px)
        .margin { 0.px }
        .fontSize(10.px)
        .styleModifier {
            property("transition", "background-color 0.3s")
        }
        .styleModifier {
            property(":hover", "{ background-color: rgb(29, 78, 216) }")
        }
}

val ButtonModifier = CssStyle.base {
    Modifier.margin(4.px).padding(0.px).fontSize(10.px).height(20.px)
}

val FormContainer = CssStyle.base {
    Modifier
        .padding(14.px)
        .backgroundColor(rgb(255, 255, 255))
        .borderRadius(8.px)
        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
        .maxWidth(450.px)
    //.maxHeight(500.px)
}

val TextSpanModifier = CssStyle.base {
    Modifier
        .fontSize(10.px)
}

val FormGroup = CssStyle.base {
    Modifier
        .margin(left = 2.px)
        .fillMaxWidth()
//        .minWidth(400.px)
        .maxWidth(650.px)
    //.maxHeight(500.px)
}

val FormLabel = CssStyle.base {
    Modifier
        .fontSize(10.px)
        .color(rgb(75, 85, 99))
        .margin(bottom = 4.px)
        .display(DisplayStyle.Block)
}

val FooterStyle = CssStyle.base {
    Modifier
        .zIndex(3)
        .fillMaxWidth() // Make sure footer takes full width
        .backgroundColor(rgb(243, 244, 246))
        .padding(8.px)
        .margin(0.px) // Remove margin
        .verticalAlign(VerticalAlign.Bottom)
        .textAlign(TextAlign.Center)
}

val SocialLinkStyle = CssStyle.base {
    Modifier
        .margin(left = 32.px)
        .color(rgb(75, 85, 99))
}


@Composable
fun SiteFooter() {
    Footer(
        attrs = FooterStyle.toModifier().margin(top=0.px).padding(0.px).height(5.percent) /*.maxWidth(800.px)*/.toAttrs()
    ) {
        Row(
            modifier = Modifier.margin(top=0.px).padding(0.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Bottom
        ) {
            Row(
                modifier = Modifier.gap(4.px)/*.maxWidth(800.px)*/,
                verticalAlignment = Alignment.Bottom
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text(COPYRIGHT_TEXT)
                }
            }
            Row(
                modifier = Modifier.gap(4.px)/*.maxWidth(800.px)*/,
                verticalAlignment = Alignment.Bottom
            ) {
                if(!INSTAGRAM_URL.isNullOrBlank()) {
                   Link(
                        INSTAGRAM_URL,
                        SocialLinkStyle.toModifier()
                    ) {
                        Image(
                            src = INSTAGRAM_ICON,
                            alt = INSTAGRAM_NAME,
                            modifier = Modifier.width(20.px).height(20.px)
                        )
                    }
                }
                if(!FACEBOOK_URL.isNullOrBlank()) {
                    Link(
                        FACEBOOK_URL,
                        SocialLinkStyle.toModifier()
                    ) {
                        Image(
                            src = FACEBOOK_ICON,
                            alt = FACEBOOK_NAME,
                            modifier = Modifier.width(20.px).height(20.px)
                        )
                    }
                }
                if(!EMAIL_URL.isNullOrBlank()) {
                    Link(
                        EMAIL_URL,
                        SocialLinkStyle.toModifier()
                    ) {
                        Image(
                            src = EMAIL_ICON,
                            alt = EMAIL_NAME,
                            modifier = Modifier.width(20.px).height(20.px)
                        )
                    }
                }
            }
        }
    }
}

// --- Spinner utilities ---
private fun ensureSpinnerCss() {
    val styleId = "inline-spinner-style"
    if (document.getElementById(styleId) != null) return
    val styleEl = document.createElement("style") as HTMLStyleElement
    styleEl.id = styleId
    styleEl.innerHTML = """
        @keyframes kbw_spin { 
            0% { transform: rotate(0deg);} 
            100% { transform: rotate(360deg);} 
        }
        .kbw-spinner {
            border: 2px solid #f3f3f3;
            border-top: 2px solid #3498db;
            border-radius: 50%;
            width: 14px;
            height: 14px;
            animation: kbw_spin 0.8s linear infinite;
            display: inline-block;
            vertical-align: middle;
        }
    """.trimIndent()
    document.head?.appendChild(styleEl)
}

@Composable
private fun Spinner() {
    ensureSpinnerCss()
    Span(Modifier.margin(right = 8.px).toAttrs {
        classes("kbw-spinner")
    })
}

fun loadMyScripts(onLoaded: () -> Unit = {}) {
    console.log("loadMyScripts")
    if (window.asDynamic().google?.maps != undefined) {
        onLoaded()
        return
    }
    val script = window.document.createElement("script") as HTMLScriptElement
    script.setAttribute("src", "/scripts/myScript.js")
    script.setAttribute("type", "text/javascript")
    console.log("Appended myScript.js script to head: ${script.src}")
    script.onload = { onLoaded() }
    window.document.head?.appendChild(script)
}

fun loadGoogleAuthScript(onLoaded: () -> Unit = {}) {
    console.log("loadGoogleAuthScript")
    val script = window.document.createElement("script") as HTMLScriptElement
    script.setAttribute("src", "/scripts/GoogleAuthScript.js")
    script.setAttribute("type", "text/javascript")
    console.log("Appended GoogleAuthScript.js script to head: ${script.src}")
    script.onload = { onLoaded() }
    window.document.head?.appendChild(script)
}


fun activateAccount(activateCode: String, email: String, onActivateSuccess : (String) -> Unit) : String{

    window.fetch(
        apiEndpoint + "/api/activate-account",
        RequestInit(
            method = "POST",
            headers = json("Content-Type" to "application/json","Accept" to "application/json"),
            body = "{\"activateCode\":\"$activateCode\", \"email\":\"$email\",\"deviceId\":\"\"" +
                    ", \"password\":\"\", \"app\":\"${SiteConfig.app}\"}"
        )
    ).then { response ->
        response.text().then { body ->
            if (response.ok) {
                onActivateSuccess(email)
                "Please check your email for confirmation."

            } else {
                console.log("Error response body: $body")
                body
            }
        }
    }
    return "Please check your email for confirmation."
}

@Composable
fun UserOnHeader(isLoggedIn: Boolean, onLogout: () -> Unit) {
    if (!isLoggedIn) {
        return
    }

    var username by remember { mutableStateOf("") }
    val storedUser = window.localStorage.getItem("username")

    if (!storedUser.isNullOrBlank()) {
        username = storedUser

        Spacer()
        Span(TextSpanModifier.toModifier().toAttrs()){
            Text("Welcome $username!  ")
        }
        com.varabyte.kobweb.silk.components.forms.Button(
            onClick = {
                username = ""
                window.localStorage.removeItem("username")
                window.localStorage.removeItem("deviceId")
                onLogout()
            },
            modifier = ButtonStyle.toModifier().backgroundColor(Colors.LightGray)
                .color(Colors.Black).height(25.px)
        ) {
            Text("Logout")
        }
    }
}

@Composable
fun StyledTextInput(
    id: String, placeHolder: String, modifier: Modifier = Modifier.position(Position.Relative)
        .fontSize(10.px).width(250.px), zIndex: Int = 1, topMargin: CSSSizeValue<CSSUnit.px> = 0.px,
    iconSize : CSSSizeValue<CSSUnit.px> = 16.px
) {
    var text by remember { mutableStateOf("") }

    Box(
        modifier = modifier
    ) {
        Row(
//            modifier = Modifier.width(80.percent),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Input(
                type = InputType.Text,
                attrs = modifier
//                    .width(250.px)
                    .padding(8.px)
//                    .fontSize(10.px)
                    .borderRadius(8.px)
                    .border(1.px, LineStyle.Solid, Color.gray)
                    .padding(6.px)
                    .toAttrs {
                        attr("placeholder", placeHolder)
                        attr("id", id)
                        attr("value", text)
                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
                            text = event.value
                        }
                    }
            )

            if (text.isNotEmpty()) {
                com.varabyte.kobweb.silk.components.forms.Button(
                    onClick = {
                        text = ""
                        val input = document.getElementById(id) as HTMLInputElement
                        input.value = ""
                        // Trigger the place_changed event to clear the map marker
                        js("document.getElementById(id).dispatchEvent(new Event('input'))")
                    },
                    modifier = Modifier
                        .position(Position.Absolute)
                        .right(8.px)
                        .padding(4.px)
                        .zIndex(zIndex)
                        .margin(top = topMargin)
                        .backgroundColor(Colors.Transparent)
//                        .backgroundColor(Colors.Black)
                        .cursor(Cursor.Pointer)
                ) {
                    Image(
                        src = "/icons/clear.svg",
                        alt = "Clear",
                        modifier = Modifier.size(iconSize)
//                        modifier = Modifier.size(64.px)
                    )
                }
            }
        }
    }
}

@Composable
fun StyledTextAreaInput(id: String, placeHolder: String) {
    var text by remember { mutableStateOf("") }

    TextArea (
        attrs = Modifier
            .width(100.percent)
            .padding(4.px)
            .fontSize(10.px)
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, Color.gray)
            .padding(4.px)
            .toAttrs {
                attr("placeholder", placeHolder)
                attr("id", id)
                attr("value", text)
                attr("rows", "4")
                attr("cols", "50")
                onInput { event ->
                    text = event.value
                }
            }
    )
}

@Composable
fun StyledCheckbox(id: String, placeHolder: String, isChecked: Boolean = false) {
    var isChecked by remember { mutableStateOf(false) }

    Span(
        TitleStyle.toModifier().whiteSpace(WhiteSpace.PreWrap).textAlign(TextAlign.Center)
            .toAttrs()
    ) {
        Label(
            attrs = Modifier
                //.width(CSSAutoKeyword)
                .padding(4.px)
                .fontSize(10.px)
                .toAttrs {
                    attr("placeholder", placeHolder)
                    attr("id", id + "_label")
                    attr("value", placeHolder)
//                onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
//                    text = event.value
//                }
                }) {
            Text(placeHolder)
        }
        Input(
            type = InputType.Checkbox,
            attrs = Modifier
//                .borderRadius(8.px)
//                .border(1.px, LineStyle.Solid, Color.gray)
                .toAttrs {
                    attr("id", id)
                    attr("checked", isChecked.toString()) // <-- ✅ value goes here!
//                onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
//                    text = event.value
//                }
                }
        )
    }
}

@Composable
fun StyledHidden(id: String, mode: String = "register") {
    var value by remember { mutableStateOf("") }

    Span(
        HiddenStyle.toModifier().whiteSpace(WhiteSpace.PreWrap).textAlign(TextAlign.Center)
            .backgroundColor(Colors.Transparent)
            .toAttrs()
    ) {
        Input(
            type = InputType.Hidden,
            attrs = Modifier
                .toAttrs {
                    attr("id", id)
                }
        )
    }
}


@Composable
fun ForgotPassword() {
    //var email by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    var messageColor by remember { mutableStateOf(Colors.Black) }

    Column(
        modifier = Modifier.fillMaxWidth().margin(top = 50.px),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Center
    ) {
        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
            Text("Forgot Password")
        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Email:")
            StyledTextInput(
                id = "forgot_password_email",
                placeHolder = "Enter your email"
                //modifier = Modifier.width(300.px).margin(bottom = 10.px)

            )
        }
//        TextInput(
//            value = email,
//            onValueChange = { email = it },
//            modifier = Modifier
//                .width(300.px)
//                .margin(bottom = 10.px),
//            placeholder = "Enter your email"
//        )

        //val coroutineScope = rememberCoroutineScope()

        Button(
            attrs = Modifier.toAttrs {
                attr("id", "resetPasswordButton")
                onClick {
                    val email =
                        (window.document.getElementById("forgot_password_email") as HTMLInputElement).value.lowercase()
                    console.log("Forgot password email: $email")
                    if (email.isNotEmpty()) {
                        window.fetch(
                            apiEndpoint + "/api/reset-password",
                            RequestInit(
                                method = "POST",
                                headers = json("Content-Type" to "application/json"),
                                body = Json.encodeToString(mapOf("email" to email, "deviceId" to "", "password" to "",
                                    "app" to SiteConfig.app))
                            )
                        ).then { response ->
                            response.text().then { body ->
                                if (response.ok) {
                                    messageColor = Colors.Green
                                    message = "Password reset instructions sent to your email"
                                } else {
                                    messageColor = Colors.Red
                                    message = body
                                }
                            }
                        }
                    } else {
                        messageColor = Colors.Red
                        message = "Please enter your email"
                    }
                }
            }) { Text("Reset Password") }

//        com.varabyte.kobweb.silk.components.forms.Button(
//            onClick = {
//                val email =
//                    (window.document.getElementById("forgot_password_email") as HTMLInputElement).value
//                console.log("Forgot password email: $email")
//                if (email.isNotEmpty()) {
//                    window.fetch(
//                        apiEndpoint + "/api/reset-password",
//                        RequestInit(
//                            method = "POST",
//                            headers = json("Content-Type" to "application/json"),
//                            body = Json.encodeToString(mapOf("email" to email, "deviceId" to "", "password" to ""))
//                        )
//                    ).then { response ->
//                        response.text().then { body ->
//                            if (response.ok) {
//                                messageColor = Colors.Green
//                                message = "Password reset instructions sent to your email"
//                            } else {
//                                messageColor = Colors.Red
//                                message = body
//                            }
//                        }
//                    }
//                } else {
//                    messageColor = Colors.Red
//                    message = "Please enter your email"
//                }
//            }
//        )
//        {
//            Text("Reset Password")
//        }

        if (message.isNotEmpty()) {
            Text(
                message
                //,modifier = Modifier.color(messageColor)
            )
        }
    }
}


@Composable
fun LoginForm(onLoginSuccess: (String, String, String) -> Unit) {
    var username by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    var showPassword by remember { mutableStateOf(false) }
    var showResetForm by remember { mutableStateOf(false) }
    // NEW
    var isLoading by remember { mutableStateOf(false) }

    Column {
        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
            Text("Login")
        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Email:")
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .toAttrs {
                        attr("placeholder", "Username")
                        attr("id", "username")
                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
                            username = event.value
                        }
                        attr("onkeydown", "if(event.key === 'Enter') document.getElementById('loginButton').click()")
                    }
            )
        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Password:")
            Input(
                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
                attrs = Modifier
                    .toAttrs {
                        attr("placeholder", "Password")
                        attr("id", "password")
                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
                            password = event.value
                        }
                        attr("onkeydown", "if(event.key === 'Enter') document.getElementById('loginButton').click()")
                    }
            )
        }
        Row(modifier = Modifier.gap(16.px)) {
            Input(
                type = InputType.Checkbox,
                attrs = Modifier.toAttrs {
                    onInput { event -> showPassword = event.value == true }
                }
            )
            Text("Show Password")
        }

        Button(
            attrs = Modifier.toAttrs {
                attr("id", "loginButton")
                if (isLoading) attr("disabled", "true")
                onClick {
                    message = ""
                    val isValidEmail = validEmail(email = username)
                    if (!isValidEmail) {
                        message = "Please enter a valid email address"
                        return@onClick
                    }
                    isLoading = true
                    window.fetch(
                        apiEndpoint + "/api/login",
                        RequestInit(
                            method = "POST",
                            headers = json(
                                "Content-Type" to "application/json",
                                "Accept" to "application/json",
                            ),
                            body = Json.encodeToString(UserCredentials("", username, password, "", SiteConfig.app))
                        )
                    )
                        .then { response ->
                            if (response.ok) {
                                response.text().then { body ->
                                    val json = JSON.parse<dynamic>(body)
                                    val name = json.username as String
                                    val deviceId = json.deviceId as String
                                    val userId = json.userId as String
                                    isLoading = false
                                    onLoginSuccess(name, deviceId, userId)
                                }
                            } else {
                                isLoading = false
                                message = "Invalid username or password"
                            }
                        }
                        .catch {
                            console.log("Error during fetch: ${it.message}")
                            isLoading = false
                            message = "An error occurred during login: ${it.message}"
                        }
                }
            }
        ) {
            if (isLoading) {
                Spinner()
                Text("Logging in...")
            } else {
                Text("Login")
            }
        }

        Text(value=message)

        Link(
            path = "",
            modifier = Modifier.onClick { showResetForm = !showResetForm }
            //,onClick = {}
        ) {
            Text("Reset Password")
        }
        if (showResetForm) {
            ForgotPassword()
        }
    }
}


//@Serializable
//data class UserCredentials(val email: String, val password: String, val deviceId: String)



private suspend fun fetch(method: String, url: String, body: dynamic = null): Response =
    window.fetch(
        url, RequestInit(
            method = method,
            body = body,
            headers = json(
                "Content-Type" to "application/json",
                "Accept" to "application/json",
                "pragma" to "no-cache"
            )
        )
    ).await()

private suspend fun post(url: String, body: dynamic): Response =
    fetch("POST", url, JSON.stringify(body))

@Composable
fun RegisterForm(onRegisterSuccess: (String) -> Unit) {
    var username by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var confirmPassword by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    var showPassword by remember { mutableStateOf(false) }
    // NEW
    var isLoading by remember { mutableStateOf(false) }

    Column {
        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
            Text("Register")
        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Email:")
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .toAttrs {
                        attr("placeholder", "Email")
                        attr("id", "username")
                        onInput { event -> username = event.value }
                        attr("onkeydown", "if(event.key === 'Enter') document.getElementById('registerButton').click()")
                    }
            )

        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Password:")
            Input(
                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
                attrs = Modifier
                    .toAttrs {
                        attr("placeholder", "Password")
                        attr("id", "password")
                        onInput { event -> password = event.value }
                        attr("onkeydown", "if(event.key === 'Enter') document.getElementById('registerButton').click()")
                    }
            )
        }
        Row(modifier = Modifier.gap(16.px)) {
            Text("Confirm Password:")
            Input(
                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
                attrs = Modifier
                    .toAttrs {
                        attr("placeholder", "Confirm Password")
                        attr("id", "confirmPassword")
                        onInput { event -> confirmPassword = event.value }
                        attr("onkeydown", "if(event.key === 'Enter') document.getElementById('registerButton').click()")
                    }
            )
        }
        Row(modifier = Modifier.gap(16.px)) {
            Input(
                type = InputType.Checkbox,
                attrs = Modifier.toAttrs {
                    onInput { event -> showPassword = event.value == true }
                }
            )
            Text("Show Password")
        }

        Button(
            attrs = Modifier.toAttrs {
                attr("id", "registerButton")
                if (isLoading) attr("disabled", "true")
                onClick {
                    message = ""
                    if (password != confirmPassword) {
                        message = "Passwords do not match"
                        return@onClick
                    }
                    val isValidEmail = validEmail(email = username)
                    if (!isValidEmail) {
                        message = "Please enter a valid email address"
                        return@onClick
                    }
                    isLoading = true
                    window.fetch(
                        apiEndpoint + "/api/register",
                        RequestInit(
                            method = "POST",
                            headers = json(
                                "Content-Type" to "application/json",
                                "Accept" to "application/json"
                            ),
                            body = Json.encodeToString(UserCredentials("", username, password, "", SiteConfig.app))
                        )
                    ).then { response ->
                        response.text().then { body ->
                            isLoading = false
                            if (response.ok) {
                                onRegisterSuccess(username)
                                message = "Please check your email for confirmation."
                            } else {
                                message = body
                                console.log("Error response body: $body")
                            }
                        }
                    }.catch {
                        isLoading = false
                        message = "An error occurred during registration: ${it.message}"
                    }
                }
            }) {
                if (isLoading) {
                    Spinner()
                    Text("Registering...")
                } else {
                    Text("Register")
                }
            }
        Text(value = message)
    }
}



@Composable
fun ResetPassForm(email:String?, resetCode:String?, onSetNewPasswordSuccess: (String, String, String) -> Unit) {
//    var username by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    // NEW
    var isLoading by remember { mutableStateOf(false) }

    Column {
        Text("Reset Password")
        Input(
            type = InputType.Text,
            attrs = Modifier
                .toAttrs {
                    attr("placeholder", "Username")
                    attr("id", "username")
                    attr("value", email?: "")
                    //onInput { event -> username = event.value }
                    attr("onkeydown", "if(event.key === 'Enter') document.getElementById('setPasswordButton').click()")
                }
        )
        Input(
            type = InputType.Password,
            attrs = Modifier
                .toAttrs {
                    attr("placeholder", "Password")
                    attr("id", "password")
                    onInput { event -> password = event.value }
                    attr("onkeydown", "if(event.key === 'Enter') document.getElementById('setPasswordButton').click()")
                }
        )

        Button(
            attrs = Modifier.toAttrs {
                attr("id", "setPasswordButton")
                if (isLoading) attr("disabled", "true")
                onClick {
                    message = ""
                    isLoading = true
                    window.fetch(
                        apiEndpoint + "/api/set-password",
                        RequestInit(
                            method = "POST",
                            headers = json("Content-Type" to "application/json","Accept" to "application/json"),
                            body = Json.encodeToString(
                                UserCredentials("",email ?: "", password, "", SiteConfig.app,
                                    true, "", resetCode ?: "")
                            )
                        )
                    ).then { response ->
                        response.text().then { body ->
                            isLoading = false
                            if (response.ok) {
                                onSetNewPasswordSuccess(email ?: "", resetCode ?: "", deviceId ?: "")
                            } else {
                                message = body
                                console.log("Error response body: $body")
                            }
                        }
                    }.catch {
                        isLoading = false
                        message = "An error occurred while setting password: ${it.message}"
                    }
                }
            }) {
                if (isLoading) {
                    Spinner()
                    Text("Setting...")
                } else {
                    Text("Set Password")
                }
            }
        Text(value=message)
    }
}


@Serializable
data class RecoveryRequest(val email: String)
